import React, { PureComponent } from 'react';
const lodashMap = require('lodash.map')

class ItemSelect extends PureComponent {

  selectedOption = (id, options) => {
    return options.find(function(option){
      return option.id === id;
    });
  }
  handleChange = event => {
    this.props.onChange(event, event.target.value, this.selectedOption(event.target.value, this.props.options))
  }

  render () {
    const {options, active, className} = this.props

    let classes = 'react-textselect'
    if (className) classes += ' ' + className

    return (
      <span className={classes}>
      <select className='react-textselect-input' onChange={this.handleChange} value={active.id}>
        {lodashMap(options, function mapOptions (value) {
          return (
            <option value={value.id} key={value.id}>{value.label}</option>
          )
        })}
        </select>
      </span>
    )
  }
}

export default ItemSelect;


// WEBPACK FOOTER //
// ./src/views/dashboard/components/items/components/ItemSelect.jsx